// MED-1268: the Create Cohort wizard saves its state to
// localStorage on every change. A wizard at the first step with nothing in it
// keeps no draft, so "Discard" leaves no draft behind.
export function isBlankDraft<V>(
  draft: { step: number; values: V; timeSlotRecovery?: unknown },
  initialValues: V
): boolean {
  return (
    draft.step === 0 &&
    !draft.timeSlotRecovery &&
    JSON.stringify(draft.values) === JSON.stringify(initialValues)
  );
}
